import React from "react";
import { type TypeAccordionSystemProps } from "./AccordionTypes";
import { AccordionContentHybrid } from "./AccordionContentHybrid";

interface TypeAccordionContentProps extends TypeAccordionSystemProps {
  children?: React.ReactNode;
}

/**
 * AccordionContent. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension).
 */
export const AccordionContent = (props: TypeAccordionContentProps) => (
  <AccordionContentHybrid {...props} />
);
